import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { m } from "@/paraglide/messages";

/** Breadcrumb (mirrors the BreadcrumbList JSON-LD). */
export function DsBreadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex flex-wrap items-center gap-1.5 text-sm text-muted-foreground"
    >
      <Link to="/" className="transition-colors hover:text-foreground">
        {m.ds_breadcrumb_home()}
      </Link>
      <ChevronRight className="h-3.5 w-3.5" aria-hidden />
      <span className="text-foreground" aria-current="page">
        {m.ds_tool_name()}
      </span>
    </nav>
  );
}
